export default "__VITE_ASSET__GQbPfGGq__"